<template>
  <div>
    <nuxt />
    <choose-user-modal ref="chooseUserModal" :user-id="userIdInsertedForChoose" :user-pwd="userPwdInsertedForChoose" :action="chooseUserAction" />
    <div id="css-loading-checking-element" />
  </div>
</template>

<script>
import ChooseUserModal from '../components/modals/ChooseUserModal'
export default {
  components: { ChooseUserModal },
  data() {
    return {
      userIdInsertedForChoose: '',
      userPwdInsertedForChoose: '',
      chooseUserAction: ''
    }
  },
  created: function() {
    const errFunc = console.error
    console.error = (...args) => {
      errFunc(...args)

      let msg = ''
      try {
        for (const arg of args) {
          if (arg instanceof Error) {
            msg = arg.message
            if (arg.stack) {
              msg += '\n' + arg.stack
            }
            break
          } else if (typeof arg === 'object') {
            if (arg && arg.data && arg.data.message) {
              msg = arg.data.message
              break
            } else if (arg && arg.message) {
              msg = arg.message
              break
            } else {
              msg = JSON.stringify(arg)
            }
          } else if (typeof arg === 'string') {
            msg = arg
            break
          }
        }
      } catch (e) {
        msg = 'Error parsing console.error arguments'
      }

      if (!msg || msg === '{}' || msg === '[]' || msg === '[object Object]') {
        msg = 'Unrecognized error: ' + JSON.stringify(args)
      }
      const params = {
        msg: msg,
        args: args,
        stackTrace: window.getStackTrace(),
        userAgent: navigator.userAgent,
        path: this.$route.fullPath,
        userId: this.loggedInUser ? this.loggedInUser.userId : '',
        userInfo: {
          userId: this.loggedInUser ? this.loggedInUser.userId : '',
          nm: this.loggedInUser ? this.loggedInUser.nm : ''
        }
      }
      this.$axios.$post('/error/public/error', params, {
        no_loading: true,
        processing: false
      })
    }
  },
  mounted() {
    this.$eventHub.$on('showChooseUserModal', this.showChooseUserModal)
  },
  beforeDestroy() {
    this.$eventHub.$off('showChooseUserModal', this.showChooseUserModal)
  },
  methods: {
    showChooseUserModal(params) {
      console.log(params)
      this.userIdInsertedForChoose = params.userId
      this.userPwdInsertedForChoose = params.userPwd ? params.userPwd : ''
      this.chooseUserAction = params.action
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs.chooseUserModal.showModalAndLoad()
      })
    }
  }
}
</script>
